import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { breakpoint, HideFor } from '@zocdoc/components/src/grid';
import { grey10, navy, white } from '@zocdoc/branding/colors';
import { sharpSansBold } from '@zocdoc/components/src/typography';

import Button from './Button';
import { Container, Headline, List, ListItem } from '../Panel';
import PinkShape from './Shape_Pink.svg';

export class ListPracticeView extends React.PureComponent {
    static propTypes = {
        trackListPracticeClick: PropTypes.func.isRequired,
    };

    render() {
        const {
            trackListPracticeClick,
        } = this.props;

        return (
            <ListPracticePanelContainer alwaysVisible>
                <div>
                    <ListPracticeHeadline>
                        <FormattedMessage
                            defaultMessage="Are you a five-star doctor?"
                            id="Home.ListPractice.FiveStarDoctor"
                        />
                    </ListPracticeHeadline>

                    <HideFor
                        xsmall
                        xxsmall
                    >
                        <ListPracticeSubTitle>
                            <FormattedMessage
                                defaultMessage="List your practice to reach millions of patients."
                                id="Home.ListPractice.ReachPatients"
                            />
                        </ListPracticeSubTitle>
                        <List>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Attract and engage new patients"
                                    id="Home.ListPractice.AttractNewPatients"
                                />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Build and strengthen your online reputation"
                                    id="Home.ListPractice.BuildReputation"
                                />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    defaultMessage="Deliver a premium experience patients love"
                                    id="Home.ListPractice.PremiumExperience"
                                />
                            </ListItem>
                        </List>
                    </HideFor>
                </div>
                <Button
                    href="/join"
                    trackListPracticeClick={trackListPracticeClick}
                >
                    <FormattedMessage
                        defaultMessage="List your practice on Zocdoc"
                        id="Home.ListPractice.ListYourPractice"
                    />
                </Button>
            </ListPracticePanelContainer>
        );
    }
}

const ListPracticePanelContainer = styled(Container)`
    display: flex;
    flex-direction: column;

    padding-top: 28px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 40px;
    align-items: center;

    background-color: ${navy};

    ${breakpoint.xsmall} {
        padding-left: 25px;
        padding-right: 25px;
    }

    ${breakpoint.small} {
        padding-top: 60px;
        padding-bottom: 80px;

        background-color: ${grey10};
        background-image: url(${PinkShape});
        background-size: auto 115%;
        background-position: 76% -100px;
        background-repeat: no-repeat;
    }
    ${breakpoint.medium} {
        align-items: flex-start;
        padding-top: 140px;

        background-position: 76% -175px;
    }
`;

const ListPracticeHeadline = styled(Headline)`
    @media screen and (max-width: 767px) {
        color: ${white};
    }
`;

const ListPracticeSubTitle = styled.h3`
    ${sharpSansBold(24, 32)};
    color: ${navy};
    padding-bottom: 18px;
`;
